/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function e(r,t,...n){if(r in t){let e=t[r];return"function"==typeof e?e(...n):e}let a=new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((e=>`"${e}"`)).join(", ")}.`);throw Error.captureStackTrace&&Error.captureStackTrace(a,e),a}export{e as match};
//# sourceMappingURL=match.js.map
